import React, { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from '../components/Button';
export function BookDemo() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate form submission
    setTimeout(() => setIsSubmitted(true), 500);
  };
  return <div className="flex min-h-[calc(100vh-4rem)] bg-slate-50" data-id="element-216">
      <div className="mx-auto max-w-7xl w-full px-4 sm:px-6 lg:px-8 py-12 lg:py-24 flex flex-col lg:flex-row gap-16 items-center lg:items-start" data-id="element-217">
        {/* Left Column - Copy */}
        <div className="flex-1 max-w-xl lg:mt-10" data-id="element-218">
          <h1 className="text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl mb-6" data-id="element-219">
            See DemandPath in action
          </h1>
          <p className="text-lg text-slate-600 mb-8" data-id="element-220">
            Book a 30-minute demo to see how we can help you clean up your
            HubSpot lead routing, enforce SLAs, and get total visibility into
            assignment logic.
          </p>

          <div className="space-y-4" data-id="element-221">
            {['Centralize your routing logic', 'Set up advanced round robin rules', 'Enforce response-time SLAs', 'Get full auditability of every assignment'].map((point, i) => <div key={i} className="flex items-center gap-3" data-id="element-222">
                <CheckCircle2 className="h-5 w-5 text-brand-600 shrink-0" data-id="element-223" />
                <span className="text-slate-700" data-id="element-224">{point}</span>
              </div>)}
          </div>
        </div>

        {/* Right Column - Form */}
        <div className="w-full max-w-md bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-200 p-8" data-id="element-225">
          {isSubmitted ? <div className="text-center py-12" data-id="element-226">
              <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100 mb-6" data-id="element-227">
                <CheckCircle2 className="h-8 w-8 text-green-600" data-id="element-228" />
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-229">
                Request Received
              </h3>
              <p className="text-slate-600 mb-8" data-id="element-230">
                Thanks for your interest! Our team will be in touch shortly to
                schedule your demo.
              </p>
              <Button onClick={() => setIsSubmitted(false)} variant="outline" className="w-full" data-id="element-231">
                Submit another request
              </Button>
            </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-232">
              <div data-id="element-233">
                <label htmlFor="name" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-234">
                  Full Name
                </label>
                <input type="text" id="name" required className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500" placeholder="Jane Doe" data-id="element-235" />
              </div>

              <div data-id="element-236">
                <label htmlFor="email" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-237">
                  Work Email
                </label>
                <input type="email" id="email" required className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500" placeholder="jane@company.com" data-id="element-238" />
              </div>

              <div data-id="element-239">
                <label htmlFor="company" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-240">
                  Company
                </label>
                <input type="text" id="company" required className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500" placeholder="Acme Corp" data-id="element-241" />
              </div>

              <div data-id="element-242">
                <label htmlFor="size" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-243">
                  Company Size
                </label>
                <select id="size" required className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 bg-white" data-id="element-244">
                  <option value="" data-id="element-245">Select size...</option>
                  <option value="1-50" data-id="element-246">1-50 employees</option>
                  <option value="51-200" data-id="element-247">51-200 employees</option>
                  <option value="201-1000" data-id="element-248">201-1000 employees</option>
                  <option value="1000+" data-id="element-249">1000+ employees</option>
                </select>
              </div>

              <div data-id="element-250">
                <label htmlFor="hubspot" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-251">
                  Do you use HubSpot?
                </label>
                <select id="hubspot" required className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 bg-white" data-id="element-252">
                  <option value="" data-id="element-253">Select...</option>
                  <option value="yes" data-id="element-254">Yes, currently using HubSpot</option>
                  <option value="migrating" data-id="element-255">Migrating to HubSpot soon</option>
                  <option value="no" data-id="element-256">No</option>
                </select>
              </div>

              <div data-id="element-257">
                <label htmlFor="challenge" className="block text-sm font-medium text-slate-900 mb-1" data-id="element-258">
                  Current routing challenge
                </label>
                <textarea id="challenge" rows={3} className="w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500" placeholder="Tell us what's broken with your current setup..." data-id="element-259"></textarea>
              </div>

              <Button type="submit" className="w-full mt-2" data-id="element-260">
                Request Demo
              </Button>
            </form>}
        </div>
      </div>
    </div>;
}